// FETCH ALL USER HEADER
export const FETCH_USER_HEADER_REQUEST = 'FETCH_USER_HEADER_REQUEST';
export const FETCH_USER_HEADER_SUCCESS = 'FETCH_USER_HEADER_SUCCESS';
export const FETCH_USER_HEADER_FAILURE = 'FETCH_USER_HEADER_FAILURE';

// CREATE USER HEADER
export const CREATE_USER_HEADER_REQUEST = 'CREATE_USER_HEADER_REQUEST';
export const CREATE_USER_HEADER_SUCCESS = 'CREATE_USER_HEADER_SUCCESS';
export const CREATE_USER_HEADER_FAILURE = 'CREATE_USER_HEADER_FAILURE';

// UPDATE USER HEADER
export const UPDATE_USER_HEADER_REQUEST = 'UPDATE_USER_HEADER_REQUEST';
export const UPDATE_USER_HEADER_SUCCESS = 'UPDATE_USER_HEADER_SUCCESS';
export const UPDATE_USER_HEADER_FAILURE = 'UPDATE_USER_HEADER_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_USER_HEADER_REQUEST = 'FETCH_SINGLE_USER_HEADER_REQUEST';
export const FETCH_SINGLE_USER_HEADER_SUCCESS = 'FETCH_SINGLE_USER_HEADER_SUCCESS';
export const FETCH_SINGLE_USER_HEADER_FAILURE = 'FETCH_SINGLE_USER_HEADER_FAILURE';

// DELETE USER HEADER
export const DELETE_USER_HEADER_REQUEST = 'DELETE_USER_HEADER_REQUEST';
export const DELETE_USER_HEADER_SUCCESS = 'DELETE_USER_HEADER_SUCCESS';
export const DELETE_USER_HEADER_FAILURE = 'DELETE_USER_HEADER_FAILURE';

export const FETCH_PROPERTY_DATAS_FOR_USER_HEADER_REQUEST = 'FETCH_PROPERTY_DATAS_FOR_USER_HEADER_REQUEST';
export const FETCH_PROPERTY_DATAS_FOR_USER_HEADER_SUCCESS = 'FETCH_PROPERTY_DATAS_FOR_USER_HEADER_SUCCESS';
export const FETCH_PROPERTY_DATAS_FOR_USER_HEADER_FAILURE = 'FETCH_PROPERTY_DATAS_FOR_USER_HEADER_FAILURE';

// LOAD COMPANY DATA FROM PROPERTY MASTER
export const FETCH_COMPANY_REQUEST = 'FETCH_COMPANY_REQUEST';
export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS';
export const FETCH_COMPANY_FAILURE = 'FETCH_COMPANY_FAILURE';

export const FETCH_USER_SIGNATURE_IMAGE_REQUEST = 'FETCH_USER_SIGNATURE_IMAGE_REQUEST';
export const FETCH_USER_SIGNATURE_IMAGE_SUCCESS = 'FETCH_USER_SIGNATURE_IMAGE_SUCCESS';
export const FETCH_USER_SIGNATURE_IMAGE_FAILURE = 'FETCH_USER_SIGNATURE_IMAGE_FAILURE';

export const RESET_USER_HEADER_INFO = 'RESET_USER_HEADER_INFO';

export const CREATE_USER_HEADER_FORM = 'CREATE_USER_HEADER_FORM';

export const UPDATE_USER_HEADER_FORM = 'UPDATE_USER_HEADER_FORM';

// NAVIGATE TO USER DETAILS COMPONENT
export const NAVIGATE_USER_DETAILS = 'NAVIGATE_USER_DETAILS';

// NAVIGATE TO USER HEADER COMPONENT
export const NAVIGATE_USER_HEADER = 'NAVIGATE_USER_HEADER';

export const SET_SIGNATURE_FILE_NAME_USER_HEADER = 'SET_SIGNATURE_FILE_NAME_USER_HEADER';

export const RESET_USER_HEADER = 'RESET_USER_HEADER'
